import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const BreadCrumbOne = ({title, page}) => {
    const { t } = useTranslation();
    return (
        <div className="breadcrum-area" style={{backgroundImage:`url(${process.env.PUBLIC_URL + "/images/banner/contact.webp"})`,backgroundSize:"cover"}}>
            <div className="container">
                <div className="breadcrumb">
                    <ul className="list-unstyled">
                        <li>
                            <Link to={ "/"}>{t('homepage')}</Link>
                        </li>
                        <li className="active" dangerouslySetInnerHTML={{__html: page}}></li>
                    </ul>
                    <p className="h1 title h2" dangerouslySetInnerHTML={{__html: title}}></p>
                </div>
            </div>
            <ul className="shape-group-8 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-9.webp"} alt="Bubble" /></li>
            </ul>
        </div>
    )
}

export default BreadCrumbOne;